    angular.module('clients')
        .directive('clientPicker', function ($rootScope, Client, ClientService) {
            return {
                require: 'ngModel',
                replace: true,
                scope: {
                    ngDisabled: '=',
                    ngRequired: '=',
                },
                templateUrl: 'app/clients/client-picker/client-picker.html',
                link: function (scope, $element, $attrs, ngModelCtrl) {

                    scope.selected = {};

                    scope.onSelected = function ($item, $model, $label, $event) {
                        // scope.text = $item.fullName;
                        scope.selected = {
                            client: {
                                id: $item.id,
                                symbol: $item.symbol
                            },
                            fullName: $item.fullName,
                            address: $item.address,
                            postcode: $item.postcode,
                            city: $item.city,
                            taxNo: $item.nip
                        };
                    };

                    scope.addClient = () => {
                        ClientService.addModal().then(client => scope.onSelected(client))
                    }
                    scope.editClient = client => {
                        ClientService.edit(client.id).then(result => scope.onSelected(result));
                    };
                    scope.clear = () => {
                        scope.selected = {};
                    };

                    scope.getCustomers = q => {
                        return Client.autocomplete({q: q}).$promise.then(items => items)
                    }
                    ngModelCtrl.$render = () => {
                        scope.selected = ngModelCtrl.$viewValue;
                        // if (ngModelCtrl.$viewValue) {
                        //     scope.text = ngModelCtrl.$viewValue.fullName;
                            // scope.selected = ngModelCtrl.$viewValue;
                        // }
                        // if(ngModelCtrl.$viewValue)
                        //     scope.text = ngModelCtrl.$viewValue;
                    };
                    ngModelCtrl.$formatters.push(modelValue => modelValue);
                    ngModelCtrl.$parsers.push(viewValue => viewValue);
                    // ngModelCtrl.$validators.isValidState = function (modelValue, viewValue) {
                    //     return !scope.inputSwitch;
                    // };
                    // scope.$watch('text', function () {
                    //     scope.selected.fullName = scope.text;
                    //     ngModelCtrl.$setViewValue(scope.selected);
                    //     ngModelCtrl.$validate();
                    //     ngModelCtrl.$render();
                    // });

                    scope.$watch('selected', () => {
                        ngModelCtrl.$setViewValue(scope.selected);
                        ngModelCtrl.$validate();
                        ngModelCtrl.$render();
                    }, true);
                }
            };
        });
